import WorkflowInstance from "../../WorkflowInstance";

export class VirtualMachineModel {

	vmName?: string[];

	subscriptionName?: string;

	resourceGroup?: string;

	applicationName?: string;

	environment?: string;

	virtualNetworkId?: string;

	virtualNetwork?: string;

	subnetName?: string;

	serverNamePrefix?: string;

	numberOfVMs?: number;

	startingNumber?: number;

	publisher?: string;

	offer?: string;

	SKU?: string;

	version?: string;

	location?: string;

	serviceLevel!: string;

	vmSize?: string;

	diskType?: string;

	diskSize?: number;

	availabilityOption?: string;

	availabilityZone?: string;

	recoveryServices?: string;

	backupPolicy?: string;

	backupVaultId?: string;

	azureBackup?: string;

	patchMode?: string;

	patchSchedule?: string;

	imageOS?: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}